import { EventBus } from "@/libs/EventBus"
import { useRef } from "react"

const editorEventBus = new EventBus();
export function useEditorEventBusInstance() {
  const ref = useRef(editorEventBus)
  
  return ref.current
}

export function getEventBusInstance() {
  return editorEventBus
}


export const EventMap = {
  nozzleEdgeClick: 'node:nozzleEdge:mouseup',
  nozzleEdgeMousedown: 'node:nozzleEdge:mousedown',
  spreadCellChange: 'spread:cell:change',
  template: {
    openSettingPanel: 'template:settingPanel:open'
  },
  deleteSvgStream: 'deleteSvgStreamFromContent',
  addSvgStream: 'addSvgStreamFromContent',
  nodeSimStateChange: 'nodeSimStateChange',
  lineJumpNodeAdded: 'lineJumpNodeAdded'
}
